export default {
    ROOT_COMPONENTS: ['footerLeft', 'footerRight', 'legalPage', 'legalPageLabel']
};
